<template>
  <div class="mb-5">
    <TableAnalysisContainer 
        :PreProcessingResult="tablePreProcessingResult"
        :AnnotationContent="tableAnnotationResult"
        :tableId="tableId"
        :tableStatus="tableStatus"
        :isInProgress="preprocessingIsInProgress"
        :isTableFileStillExisting="tableIsTableFileStillExisting"
        v-on:start-table-preprocessing="startTablePreProcessing($event)"
        v-on:refresh-table="refreshTable"
        v-on:start-table-annotation="startTableAnnotation($event)">
    </TableAnalysisContainer>
  </div>
</template>
<script>
import TableAnalysisContainer from "./content/TableAnalysisContainer";
import TableApi from "../../generatedApiClient/api/endpoints/TableApi";
import StatusManager from "../../model/StatusManager";
import MessageDisplayerService from '../../utils/MessageDisplayerService';

let tableApiInstance = new TableApi();

export default {
  name: "Table",
  props: ["tableId"],
  components: {
    TableAnalysisContainer
  },
  data() {
    return {
      tablePreProcessingResult: undefined,
      tableAnnotationResult: undefined,
      tableStatus: undefined,
      tableIsTableFileStillExisting: undefined,
      preprocessingResultDate: undefined,
      annotationResultDate: undefined
    }
  },
  mounted() {
    this.refreshTable();
  },
  computed: {
    signedUser: function() {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
    selectedProjectId: function() {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.id : undefined;
    },
    annotationIsInProgress: function() {
      if (StatusManager.STATUS_LIST_FOR_ANNOTATION_TASK_NOT_FINISHED.includes(this.tableStatus)) {
        return true;
      } else {
        return false;
      }
    },
    preprocessingIsInProgress: function() {
      if (StatusManager.STATUS_LIST_FOR_PREPROCESSING_TASK_NOT_FINISHED.includes(this.tableStatus)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    refreshTable: function() {
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.getTable(this.signedUser, this.selectedProjectId, this.tableId, {withRefresh:true})
        .then(getTableResp => {
          console.log("[refreshTable] [API] [getTable] [OK]");
          this.setTableStatus(getTableResp.status);
          this.setTableIsTableFileStillExisting(getTableResp.isTableFileStillExisting);
          MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_TABLE);
          if (StatusManager.STATUS_LIST_FOR_PREPROCESSING_TASK_DONE_WITH_SUCCESS.includes(getTableResp.status)) {
            if ((this.preprocessingResultDate === undefined) || (this.preprocessingResultDate !== getTableResp.preprocessingTask.resultDate)) {
              this.getPreProcessingResult();
            } else {
              MessageDisplayerService.showText('Preprocessing result not modifed');
            }
          }
          if (StatusManager.STATUS_LIST_FOR_ANNOTATION_TASK_DONE_WITH_SUCCESS.includes(getTableResp.status)) {
            if ((this.annotationResultDate === undefined) || (this.annotationResultDate !== getTableResp.annotationTask.resultDate)) {
              this.getAnnotationResult();
            } else {
              MessageDisplayerService.showText('Annotation result not modifed');
            }
          }
        })
        .catch(getTableError => {
          console.log("[refreshTable] [API] [getTable] [ERROR]", getTableError);
          MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_TABLE, getTableError);
        });
    },
    getPreProcessingResult: function () {
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.getPreProcessingResult(this.signedUser, this.selectedProjectId, this.tableId)
        .then(getPreProcessingResp => {
          console.log("[getPreProcessingResult] [API] [getPreProcessingResult] [OK]");
          MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_PREPROCESSING_RESULT);
          this.setTableStatus(getPreProcessingResp.status);
          if (getPreProcessingResp.preprocessingTask.result !== undefined) {
            this.tablePreProcessingResult = getPreProcessingResp.preprocessingTask.result;
            this.preprocessingResultDate = getPreProcessingResp.preprocessingTask.resultDate;
          }
        })
        .catch(getPreProcessingError => {
          console.log("[getPreProcessingResult] [API] [getPreProcessingResult] [ERROR]", getPreProcessingError);
          MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_PREPROCESSING_RESULT, getPreProcessingError);
        });
    },
    getAnnotationResult: function () {
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.getAnnotationResult(this.signedUser, this.selectedProjectId, this.tableId)
        .then(getAnnotationResp => {
          console.log("[getAnnotationResult] [API] [getAnnotationResult] [OK]");
          MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_ANNOTATION_RESULT);
          this.setTableStatus(getAnnotationResp.status);
          // remove CPAs with (A::B) from annotation result
          this.tableAnnotationResult = this.getAnnotationResultWithoutComplexCPAs(getAnnotationResp.annotationTask.result);
          // console.log("[getAnnotationResult] this.tableAnnotationResult = ", JSON.stringify(this.tableAnnotationResult));
          this.annotationResultDate = getAnnotationResp.annotationTask.resultDate;
        })
        .catch(getAnnotationError => {
          console.log("[getAnnotationResult] [API] [getAnnotationResult] [ERROR]", getAnnotationError);
          MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_ANNOTATION_RESULT, getAnnotationError);
        });
    },
    getAnnotationResultWithoutComplexCPAs: function(resultArray) {
      if ((resultArray) && (Array.isArray(resultArray))) {
        const returnedAnnotationResultWithoutComplexCPAs = resultArray.map((result) => {
          const returnedResult = { ...result };
          if ((returnedResult.annotated) && (returnedResult.annotated.CPA) && (Array.isArray(returnedResult.annotated.CPA))) {
            const cpaUriToRemoveRegex = new RegExp('\\(http');
            returnedResult.annotated.CPA = returnedResult.annotated.CPA.filter(cpa => ((cpa.annotation) && (cpa.annotation.uri) && (!cpaUriToRemoveRegex.test(cpa.annotation.uri))));
          }
          // console.log("[getAnnotationResultWithoutComplexCPAs] returnedResult.annotated.CPA =  ", returnedResult.annotated.CPA);
          return returnedResult;
        })
        return returnedAnnotationResultWithoutComplexCPAs;
      } else {
        return resultArray;
      }
    },
    startTablePreProcessing: function() {
      this.tablePreProcessingResult = undefined;
      this.tableAnnotationResult = undefined;
      // set this status because this action is launched
      this.setTableStatus('PRE PROCESSING IN PROGRESS');
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(tableApiInstance);
        tableApiInstance.launchPreProcessing(this.signedUser, this.selectedProjectId, this.tableId)
          .then(launchPreProcessingResp => {
            console.log("[startTablePreProcessing] [API] [launchPreProcessing] [OK]");
            resolve(launchPreProcessingResp);
          })
          .catch(launchPreProcessingError => {
            console.log("[startTablePreProcessing] [API] [launchPreProcessing] [ERROR]", launchPreProcessingError);
            // To reset status from real table
            this.refreshTable();
            reject(launchPreProcessingError);
          });
      });
    },
    startTableAnnotation: function() {
      this.tableAnnotationResult = undefined;
      // set this status because this action is launched
      this.setTableStatus('ANNOTATION IN PROGRESS');
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(tableApiInstance);
        tableApiInstance.launchAnnotation(this.signedUser, this.selectedProjectId, this.tableId)
            .then(launchAnnotationResp => {
              console.log("[startTableAnnotation] [API] [launchAnnotation] [OK]");
              resolve(launchAnnotationResp);
            })
            .catch(launchAnnotationError => {
              console.log("[startTableAnnotation] [API] [launchAnnotation] [ERROR]", launchAnnotationError);
              // To reset status from real table
              this.refreshTable();
              reject(launchAnnotationError);
            });
      });
    },
    setTableStatus: function(status) {
      this.tableStatus = status;
    },
    setTableIsTableFileStillExisting: function(isTableFileStillExisting) {
      this.tableIsTableFileStillExisting = isTableFileStillExisting;
    }
  }

};
</script>
<style scoped>

</style>